import { render, staticRenderFns } from "./PassagesPoint.vue?vue&type=template&id=3c125626&scoped=true&"
import script from "./PassagesPoint.vue?vue&type=script&lang=js&"
export * from "./PassagesPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c125626",
  null
  
)

export default component.exports